import React from 'react';
import styled from 'styled-components';
export const Watermark = ({
  label
}) => {
  return /*#__PURE__*/React.createElement(Center, null, "\u2014\u2014", label, "\u2014\u2014");
};
const Center = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 30px 0;
  color: #d6d6d6;
  font-size: 14px;
`;
export default Watermark;